/**
 * Simple brand switcher - just switches asset paths and CSS files
 */

const BRAND_STORAGE_KEY = 'activeBrand';
const DEFAULT_BRAND = '';

export function getActiveBrand(): string {
  return localStorage.getItem(BRAND_STORAGE_KEY) || DEFAULT_BRAND;
}

export function setActiveBrand(brand: string): void {
  localStorage.setItem(BRAND_STORAGE_KEY, brand);
  updateCSS(brand);
  // Trigger a custom event so components can react
  window.dispatchEvent(new CustomEvent('brandChanged', { detail: { brand } }));
}

export function getAssetPath(path: string): string {
  const brand = getActiveBrand();
  if (!brand) return path;
  
  // Replace /assets/identity/ with /assets/identity-{brand}/
  // Or handle other asset paths as needed
  if (path.includes('/assets/identity/')) {
    return path.replace('/assets/identity/', `/assets/identity-${brand}/`);
  }
  
  // For other assets, you can add more rules here
  return path;
}

function updateCSS(brand: string): void {
  // Remove old brand CSS
  const oldLink = document.getElementById('brand-css');
  if (oldLink) {
    oldLink.remove();
  }
  
  // Add new brand CSS if brand is set
  if (brand) {
    const link = document.createElement('link');
    link.id = 'brand-css';
    link.rel = 'stylesheet';
    link.href = `/globals-${brand}.css`;
    document.head.appendChild(link);
  }
}

// Initialize CSS on load
if (typeof window !== 'undefined') {
  const brand = getActiveBrand();
  if (brand) {
    updateCSS(brand);
  }
}

